import React from 'react';
import { Routes, Route } from 'react-router-dom';
import RefillsPage from '@pages/refills/RefillsPage';
import RefillCreatePage from '@pages/refills/RefillCreatePage';
import RefillEditPage from '@pages/refills/RefillEditPage';
import RefillViewPage from '@pages/refills/RefillViewPage';

export const RefillsRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<RefillsPage />} />
            <Route path="/create" element={<RefillCreatePage />} />
            <Route path="/:id" element={<RefillViewPage />} />
            <Route path="/:id/edit" element={<RefillEditPage />} />
        </Routes>
    );
};

export default RefillsRoutes;
